import request from '@/assets/js/request'

/**
 * 获取用户信息
 * @returns 用户信息
 */
export function getUserInfo() {
    return request.get('/jbbcs/user/getUserInfo')
}



// WEBPACK FOOTER //
// ./src/apis/user.js